import { Fade, Zoom } from "react-awesome-reveal";
import { MAILTO_COMMERCIAL, TEL_SEGRETERIA } from "../../../../constants/contacts";
import Button from "../../../../components/ui/button/button";

import "./home-new-project.scss";

const HomeNewProject = ({ isMobile }: { isMobile: boolean }) => {
  return (
    <section className="home-new-project">
      <Fade direction="up" duration={800} triggerOnce>
        <h2 className="home-new-project__title">Hai un Progetto?</h2>
      </Fade>
      <Fade direction="up" delay={150} duration={800} triggerOnce>
        <p className="home-new-project__text">
          Contattaci per una consulenza gratuita e scopri come possiamo aiutarti
          a realizzare il tuo progetto con sicurezza e precisione.
        </p>
      </Fade>
      <Zoom delay={300} duration={800} triggerOnce>
        <div className="home-new-project__buttons">
          <Button
            text="Chiamaci Ora"
            type="primary"
            iconName="phone"
            fullWidth={!!isMobile}
            href={TEL_SEGRETERIA}
          />
          <Button
            text="Invia Email"
            type="secondary"
            iconName="envelope"
            fullWidth={!!isMobile}
            href={MAILTO_COMMERCIAL}
          />
        </div>
      </Zoom>
    </section>
  );
};

export default HomeNewProject;
